<template>
  <div class="calculator-rate">
    <div class="calculator-rate__price">
      1 {{ cryptoCurrency?.code }} = {{ currentPrice }} {{ fiatCurrency?.code }}
    </div>
    <div class="calculator-rate__disclaimer">
      {{ $t('calculator.form-footer.rate-disclaimer') }}
    </div>
  </div>
</template>

<script setup lang="ts">
import store from "@/store/calculator";
import { computed } from "vue";
import { NumberFormatter } from "@/helpers/numberFormatter";

const fiatCurrency = computed(() => store.state.calculator.selectedFiatCurrency);
const cryptoCurrency = computed(() => store.state.calculator.selectedCryptoCurrency);

const currentPrice = computed(() => {
  if (!fiatCurrency.value) {
    return "0";
  }
  const price = store.state.calculator.price;
  const numberFormatter = new NumberFormatter(store.state.language);
  if (price < 10) {
    numberFormatter.setMaxSignificantDigits(4);
  }

  return numberFormatter.format(Number(price));
});
</script>

<style scoped lang="scss">

</style>